import React from 'react'
import styled from 'styled-components'

interface DealerInfo {
  site_uri: string
  full_name: string
  address: string
}
interface Props {
  storedDealerInfo?: DealerInfo
  nextDealerInfo: DealerInfo
}
export const ShowNextDealer = ({ nextDealerInfo, storedDealerInfo }: Props) => {
  return storedDealerInfo ? (
    <>
      <TextShowNextDealer>
        В данный момент автомобили в ДЦ «{storedDealerInfo?.full_name}» отсутствуют.
      </TextShowNextDealer>
      <TextShowNextDealer>
        Ниже представлены автомобили в наличии дилерского центра «{nextDealerInfo?.full_name} {nextDealerInfo?.address}»
      </TextShowNextDealer>
    </>
  ) : (
    <TextShowNextDealer>
      Автомобили в дилерском центре «{nextDealerInfo?.full_name} по адресу: {nextDealerInfo?.address}»
    </TextShowNextDealer>
  )
}

const TextShowNextDealer = styled.p`
  ${({ theme }) => theme.textStyles.p1};
  font-size: 19px;
  font-weight: normal;
  text-align: center;
`
